import LetsGo from "../components/models/getting-started";
import ModelsDescription from "../components/models/model-description";
import ModelsMain from "../components/models/models-main";

function Models() {
    return ( 
        <>
            <ModelsMain />
            <ModelsDescription />
            <LetsGo />
        </>
     );
}

export default Models;